import { render } from "./candidates-list.vue?vue&type=template&id=4a0a05ff"
import script from "./candidates-list.vue?vue&type=script&lang=js"
export * from "./candidates-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__